import React from "react";
import ClaroParagraph from '../../atoms/ClaroParagraph'

const HeaderPaymentFormClaroSocio = ({generalInfo, isContainerTelcel, isClaroPartner}) => {

    const { logo:{ base64, margin, padding, height, width, alt }, title, subtitle } = generalInfo
    
    return(
        <>  
            <img
                style={{margin: margin, padding: padding}}
                src={base64}
                alt={alt}
                height={height}
                width={width}
            />
            <ClaroParagraph 
                align="center"
                fontColor={isContainerTelcel && !isClaroPartner ? "#222222" : "black"}
                font-size={isContainerTelcel && !isClaroPartner ? "14px" : "13px"}
                fontFamily= "AMX-Regular" 
            >
                {title}
            </ClaroParagraph>
            <ClaroParagraph 
                align="center"
                fontColor={isContainerTelcel && !isClaroPartner ? "#222222" : "black"}
                padding=".5em 0em 2em 0em"
                font-size={isContainerTelcel && !isClaroPartner ? "14px" : "13px"}
                fontFamily="AMX-Regular" 
            >
                {subtitle}
            </ClaroParagraph>
        </>
    )
}

export default HeaderPaymentFormClaroSocio;